import { ProductCarouselData, ServiceTypeOrderItem } from '@msc-b2c/interfaces/types';

export function buildProductCarouPoolData(
  serviceTypesWithItemCodes: ServiceTypeOrderItem[] | any,
  matchedExcursionItemCodes: string[],
  matchedOBSItemCodes: Record<string, string[]>,
  productCarouselData: ProductCarouselData
) {
  // Build per-service-type code pools
  const serviceTypePools = serviceTypesWithItemCodes.map((serviceType: any) => {
    if (serviceType.type === 'EXCURSIONS') {
      return {
        type: serviceType.type,
        itemCodes: [...matchedExcursionItemCodes],
        fallbackCodes: productCarouselData.excursionsData
          .filter(
            (i) =>
              !!i.code &&
              !matchedExcursionItemCodes.includes(i.code) &&
              Number(i.inventory?.numberAvailable) !== 0
          )
          .map((i) => i.code)
          .filter((code): code is string => !!code),
      };
    } else {
      const matched = matchedOBSItemCodes[serviceType.type] ?? [];
      return {
        type: serviceType.type,
        itemCodes: [...matched],
        fallbackCodes: productCarouselData.obsData
          .filter((i) => i.type.code === serviceType.type && !matched.includes(i.code ?? ''))
          .map((i) => i.code)
          .filter((code): code is string => !!code),
      };
    }
  });

  return serviceTypePools;
}
